import React, { useContext } from 'react'
import { AppColors } from '../css/AppColors';
import '../css/sb-admin-2.min.css'
import '../App.css';
import { Link, useHistory, Redirect, Route } from "react-router-dom";

import { useEffect, useState } from 'react';
import { apiRequest } from '../utils/apiCalls';



import { Context } from '../Context/DataContext';
import { Modal } from 'react-bootstrap';

const Login = () => {

    const history = useHistory();
    const [loading, setLoading] = useState(false)
    const [loginData, setLoginData] = useState({
        st_email: 'zaheer@qwpcorp.com',
        st_password: '1234'
    })
    const [logined, setLogined] = useState('0')
    const { state, setStoreData } = useContext(Context)

    useEffect(() => {
        // localStorage.removeItem('store_data')
        var checklogin = []
        checklogin = localStorage.getItem('store_data')
        console.log(checklogin)
        if (checklogin) {
            // localStorage.getItem('store_data') ?
            setStoreData()
            setLogined('1')
        }
        else setLogined('2')

    }, [])





    function login() {


        if (!loginData.st_email) {
            alert('please enter a valid email')
            return
        }
        if (!loginData.st_password) {
            alert('please enter password')
            return
        }
        setLoading(true)
        apiRequest(loginData, 'login')
            .then(data => {
                console.log(data)
                setLoading(false)
                if (data.status == '1') {
                    localStorage.setItem('store_data', JSON.stringify(data.data[0]))
                    setStoreData();
                    // reactLocalStorage.set('store_data', 'data.data')
                    setLoading(false)
                    history.push("/dashboard");
                }
                else {
                    alert(data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                alert('Internet Error')
                console.log(err)
                console.log('asd')
            })
    }

    if (logined == '0') {
        return (
            <Modal
                show={true}
                onHide={() => setLoading(false)}
            >

                <Modal.Body class="text-center" >
                    <div
                        class="text-center"
                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                </Modal.Body>

            </Modal>
        )
    }

    return (
        <Route render={(props) => (
            logined == '2' ?
                <div style={{ width: "100%", height: "100vh", backgroundColor: '#0A4722' }} >
                    {/* <title>SB Admin 2 - Login</title> */}
                    <div className="container" >
                        {/* Outer Row */}
                        <div className="row justify-content-center">
                            <div className="col-xl-9 col-lg-12 col-md-9">
                                <div className="card o-hidden border-0 shadow-lg my-5">
                                    <div className="card-body p-0">
                                        {/* Nested Row within Card Body */}
                                        <div className="row">
                                            <div className="col-lg-6 d-none d-lg-block bg-login-image" />
                                            <div className="col-lg-6">
                                                <div className="p-5">
                                                    <div className="text-center">
                                                        <h1 className="h4 text-gray-900 mb-4 RRe " style={{ fontFamily: 'RBo' }} >Welcome Back!</h1>
                                                    </div>
                                                    <form className="user">
                                                        <div className="form-group">
                                                            <input
                                                                type="email"
                                                                value={loginData.st_email}
                                                                className="form-control form-control-user"
                                                                id="exampleInputEmail"
                                                                aria-describedby="emailHelp"
                                                                placeholder="Enter Email Address..."
                                                                style={{ fontFamily: "RMe" }}
                                                                onChange={(t) => {
                                                                    setLoginData({
                                                                        ...loginData,
                                                                        st_email: t.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <input
                                                                type="password"
                                                                value={loginData.st_password}
                                                                className="form-control form-control-user"
                                                                id="exampleInputPassword"
                                                                placeholder="Password"
                                                                style={{ fontFamily: "RMe" }}
                                                                onChange={(t) => {
                                                                    setLoginData({
                                                                        ...loginData,
                                                                        st_password: t.target.value
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <div className="custom-control custom-checkbox small">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id="customCheck"
                                                                />
                                                                <label
                                                                    className="custom-control-label"
                                                                    htmlFor="customCheck"
                                                                    style={{ fontFamily: "RMe" }}
                                                                >
                                                                    Remember Me
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div
                                                            onClick={() => login()}
                                                            className="btn btn-user btn-block"
                                                            style={{ borderWidth: 2, borderColor: AppColors.primary }}
                                                        >
                                                            {

                                                                loading ?
                                                                    <div class="spinner-border text-light " role="status"></div>
                                                                    :
                                                                    "Login"

                                                            }

                                                        </div>
                                                    </form>
                                                    <hr />
                                                    {/* <div className="text-center">
                                                        <a className="small" href="forgot-password.html">
                                                            Forgot Password?
                                                        </a>
                                                    </div> */}
                                                    {/* <div className="text-center">
                                                        <Link
                                                            to="/signup"
                                                            className="small" href="register.html">
                                                            Create an Account!
                                                        </Link>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : <Redirect to='/dashboard' />
        )} />
    )
}

export default Login
